import { recentClaimApiService } from "@/services/recentClaim-api.service";

const SET_RECENT_CLAIMS_LIST = 'SET_RECENT_CLAIMS_LIST'
const SET_ROOT_CLAIMS_LIST = 'setClaimsList'

const USE_ROOT_STATE = true

const state = () => ({
    recentClaimList:[]
})

const getters = {
    recentClaimList: (state, getters, rootState) => {
        if (USE_ROOT_STATE) {
            return rootState.claimsList
        } else {
            return state.recentClaimList
        }
    }
}

const mutations = {
    [SET_RECENT_CLAIMS_LIST](state, payload) {
        state.recentClaimList = payload
    },
}

const actions = {
    reset({ commit }) {
        if (USE_ROOT_STATE) {
            //
        } else {
            commit(SET_RECENT_CLAIMS_LIST, [])
        }
    },
    fetchRecentClaimsList({ commit }) {
        return new Promise((resolve, reject) => {
            if (USE_ROOT_STATE) {
                commit(SET_ROOT_CLAIMS_LIST, [], { root: true })
            } else {
                commit(SET_RECENT_CLAIMS_LIST, [])
            }
            recentClaimApiService
                .getForLoggedOnUser()
                .then(response => {
                    let { data: apiResponse } = response
                    if (response.status == 200) {
                        if (apiResponse) {
                            let { data } = apiResponse
                            if (USE_ROOT_STATE) {
                                commit(SET_ROOT_CLAIMS_LIST, data, { root: true })
                            } else {
                                commit(SET_RECENT_CLAIMS_LIST, data)
                            }
                        }
                    }
                    resolve(apiResponse);
                })
                .catch(error => {
                    reject(error);
                })
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}